<template>
    <div class="common-layouts">
        <div style="width: 3%;">
            <el-popover :visible="show" placement="right-start" :width="230" style="height: 300px">
                <template #reference>
                    <el-menu default-active="1" class="el-menu-vertical-demo" background-color="#ffffff00"
                        style="border-right: solid 0px;display: flex;justify-content: center;align-items: center;">
                        <el-menu-item index="1">
                            <template #title>
                                <img @click="show = !show" style="width: 25px; height: 25px; "
                                    src="../../../assets/img/icon_1.png" />
                            </template>
                        </el-menu-item>
                    </el-menu>
                </template>
                <el-table :data="filterTableData" border style="width: 100%;" max-height="500" @cell-click="cellClick">
                    <el-table-column align="center" prop="label" label="label">
                        <template #default="scope">
                            <span v-if="scope.row.online_status == '离线'"
                                style="width: 10px;height: 10px;background-color: #909399;border-radius: 50%;float: left;margin-top: 6px;">
                            </span>
                            <div v-else
                                style="width: 10px;height: 10px;background-color: #67c23a;border-radius: 50%;float: left;margin-top: 6px;">
                            </div>
                            {{ scope.row.label }}
                        </template>
                        <template #header>
                            <el-input v-model="search" size="large" suffix-icon="search" placeholder="输入车辆编号" clearable />
                        </template>

                    </el-table-column>
                    <!-- <el-table-column label="" prop="online_status"></el-table-column> -->
                </el-table>
            </el-popover>
        </div>
        <div class="main_boxs">
            <div class="main_maps">
                <div v-loading="loading" style="width: 100%; height: 100%" id="containers"></div>
            </div>
            <div class="ganzhi_noxs">
                <div style="width: 100%; height: 100%; background-color: #fff">
                    <div style="width: 100%; height: 15%; background-color: #2a5caa">
                        <div class="car_status">
                            <div style="float: left">车辆状态：</div>
                            <span v-if="carInfo.online_status == '离线'" style="
                width: 20px;
                height: 20px;
                background-color: #909399;
                border-radius: 50%;
                float: left;
                margin-top: 13px;
              ">
                            </span>
                            <div v-else style="
                width: 20px;
                height: 20px;
                background-color: #67c23a;
                border-radius: 50%;
                float: left;
                margin-top: 13px;
              "></div>
                            <div style="float: left; margin-left: 5px">
                                {{ carInfo.online_status }}
                            </div>
                        </div>
                        <div class="gps_status">
                            <div style="float: left">GPS状态：</div>
                            <span v-if="carInfo.online_status == '离线'" style="
                width: 20px;
                height: 20px;
                background-color: #909399;
                border-radius: 50%;
                float: left;
                margin-top: 13px;
              ">
                            </span>
                            <div v-else style="
                width: 20px;
                height: 20px;
                background-color: #67c23a;
                border-radius: 50%;
                float: left;
                margin-top: 13px;
              "></div>
                            <div style="float: left; margin-left: 5px">
                                {{ carInfo.online_status }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-descriptions :column="6" border size="large">
                            <el-descriptions-item label="车辆编号" label-align="center" align="center">
                                {{ carInfo.car?.vin || "--" }}
                            </el-descriptions-item>
                            <el-descriptions-item label="上报时间" label-align="center" align="center">{{
                                car_decimal(carInfo.dynamic?.last_upload_data_time?.data_name)
                            }}</el-descriptions-item>
                            <el-descriptions-item label="车辆速度" label-align="center" align="center">{{
                                decimal(carInfo.dynamic?.car_speed?.data, 1)
                            }} Km/h</el-descriptions-item>
                            <el-descriptions-item label="电机转速" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.motor_speed?.data, 1) }} r/min
                            </el-descriptions-item>
                            <el-descriptions-item label="母线电流" label-align="center" align="center">
                                {{
                                    decimal(carInfo.dynamic?.motor_controller_bus_current?.data, 1)
                                }} A
                            </el-descriptions-item>
                            <el-descriptions-item label="当前电流" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.current_total_current?.data, 1) }} A
                            </el-descriptions-item>
                            <el-descriptions-item label="车牌号" label-align="center" align="center">
                                {{ carInfo.car?.carNumber || "--" }}
                            </el-descriptions-item>
                            <el-descriptions-item label="运行状态" label-align="center" align="center">
                                {{
                                    decimal(carInfo.dynamic?.motor_controller_bus_current?.data, 1)
                                }}
                            </el-descriptions-item>
                            <el-descriptions-item label="累计里程" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.total_mileage?.data, 1) }} Km
                            </el-descriptions-item>
                            <el-descriptions-item label="电机扭矩" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.motor_torque?.data, 1) }} Nm
                            </el-descriptions-item>
                            <el-descriptions-item label="母线电压" label-align="center" align="center">
                                {{
                                    decimal(carInfo.dynamic?.motor_controller_input_voltage?.data, 1)
                                }} V
                            </el-descriptions-item>
                            <el-descriptions-item label="充电状态" label-align="center" align="center">
                                {{ car_decimal(carInfo.dynamic?.charging_status?.data_name) }}
                            </el-descriptions-item>
                            <el-descriptions-item label="车辆型号" label-align="center" align="center">
                                {{ carInfo.car?.carType?.serialNumber || "--" }}
                            </el-descriptions-item>
                            <el-descriptions-item label="急停状态" label-align="center" align="center">
                                {{ car_decimal(carInfo.dynamic?.stop_state?.data_name) }}
                            </el-descriptions-item>
                            <el-descriptions-item label="制动状态" label-align="center" align="center">
                                {{ car_decimal(carInfo.dynamic?.braking_state?.data_name) }}
                            </el-descriptions-item>
                            <el-descriptions-item label="控制器温度" label-align="center" align="center">
                                {{
                                    decimal(carInfo.dynamic?.motor_controller_temperature?.data, 1)
                                }} ℃
                            </el-descriptions-item>
                            <el-descriptions-item label="转向角度" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.current_angle?.data, 0) }} °
                            </el-descriptions-item>
                            <el-descriptions-item label="当前档位" label-align="center" align="center">
                                {{ car_decimal(carInfo.dynamic?.gear?.data_name) }}
                            </el-descriptions-item>
                            <el-descriptions-item label="车辆类型" label-align="center" align="center">
                                {{ carInfo.car?.carType?.name || "--" }}
                            </el-descriptions-item>
                            <el-descriptions-item label="当前电压" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.current_total_voltage?.data, 1) }} V
                            </el-descriptions-item>
                            <el-descriptions-item label="剩余电量" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.electricity?.data, 0) }} %
                            </el-descriptions-item>
                            <el-descriptions-item label="电机温度" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.drive_motor_temperature?.data, 1) }} ℃
                            </el-descriptions-item>
                            <el-descriptions-item label="EPS温度" label-align="center" align="center">
                                {{
                                    decimal(carInfo.dynamic?.steering_motor_temperature?.data, 1)
                                }} ℃
                            </el-descriptions-item>
                            <el-descriptions-item label="电机电流" label-align="center" align="center">
                                {{ decimal(carInfo.dynamic?.steering_motor_current?.data, 1) }} A
                            </el-descriptions-item>
                            <el-descriptions-item label="当前位置" label-align="center" align="center" :span="3">
                                {{ address || "--" }}
                            </el-descriptions-item>
                            <el-descriptions-item label="程序编号" label-align="center" align="center" :span="3">
                                {{
                                    edition(
                                        carInfo.dynamic?.major_version?.data,
                                        carInfo.dynamic?.sub_version?.data,
                                        carInfo.dynamic?.revised_version?.data,
                                        carInfo.dynamic?.date_number?.data
                                    )
                                }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, defineComponent, ref, computed, onBeforeUnmount, onMounted } from 'vue';
import {
    get_company_car,
    get_car_dynamic_monitoring_car_gps,
    get_car_monitoring_car_info
} from '../../../api/car_monitoring/car_monitoring'
// 定义接口来定义对象的类型
let marker = null
let conMap = null
let timer = null
export default defineComponent({
    name: 'systemDept',
    setup(props, context) {
        const state = reactive({
            carData: [],
            carInfo: {},
            openOne: true,
            gps: "",
            address: "",
            count: 0,
        });
        const show = ref(false)
        const search = ref('')
        const loading = ref(false)

        // 打开弹窗
        const openDialog = () => {
            getMap()
            getCar()
        }
        const filterTableData = computed(() =>
            state.carData.filter(
                (data) =>
                    !search.value ||
                    data.value.toLowerCase().includes(search.value.toLowerCase())
            )
        )
        //获取车辆下拉列表
        const getCar = () => {
            get_company_car().then((res) => {
                state.carData = res.data
            })
        }
        const getCarInfo = (vin) => {
            get_car_monitoring_car_info(vin).then((res) => {
                state.carInfo = res.data
                state.carInfo.online_status = state.carInfo.online_status == "0" ? "离线" : "在线"
            })
        }
        //获取车辆信息
        const cellClick = (row) => {
            state.count++
            show.value = false
            state.address = "--"
            search.value = ""
            loading.value = true
            // marker = null
            state.openOne = true
            clearInterval(timer)
            getAddressData(row.value)
            setTimeout(() => {
                loading.value = false
            }, 3000)
            timer = setInterval(() => {
                getCarInfo(row.value)
                guiji(row.value)
            }, 2000);
        }
        // 坐标转换
        const getAddressData = (id) => {
            get_car_dynamic_monitoring_car_gps(id).then(res => {
                if (res.data) {
                    state.gps = res.data
                    AMap.plugin("AMap.Geocoder", function () {
                        var geocoder = new AMap.Geocoder({
                            city: "010", //城市设为北京，默认：“全国”
                            radius: 1000, //范围，默认：500
                        });
                        var lnglat = [];
                        var _lnglat = [];
                        lnglat.push(res.data.longitude);
                        lnglat.push(res.data.latitude);
                        AMap.convertFrom(lnglat, res.data.gps_type, function (status, result) {
                            if (result.info === 'ok') {
                                var resLnglat = result.locations[0];
                                _lnglat.push(resLnglat.lng);
                                _lnglat.push(resLnglat.lat);
                                geocoder.getAddress(_lnglat, function (status, result) {
                                    if (status === "complete" && result.regeocode) {
                                        var address = result.regeocode.formattedAddress;
                                        state.address = address;
                                    }
                                });
                            }
                        });
                    });
                }
            })
        }
        const getMap = () => {
            conMap = new AMap.Map("containers", {
                // mapStyle: "amap://styles/blue",//改变地图样式
                resizeEnable: true, //是否监控地图容器尺寸变化
                zoom: 18, //初始化地图层级
                center: [118.216513, 36.810216], //初始化地图中心点
            })
        }
        const guiji = (id) => {
            get_car_dynamic_monitoring_car_gps(id).then((res) => {
                // 创建一个 Icon
                let startIcon = new AMap.Icon({
                    image:
                        "https://qlzxapi.suntaeiv.com/static/images/94fb15c9bff066c05b8be2e7322bb6b.png",
                    // 图标所用图片大小
                    imageSize: new AMap.Size(30, 40),
                });
                if (!marker) {
                    marker = new AMap.Marker({
                        position: [0, 0],
                        icon: startIcon,
                        offset: new AMap.Pixel(-13, -30),
                    });
                    marker.setMap(conMap);
                }
                if (res.data) {
                    let course = res.data.course
                    let gps_type = res.data.gps_type
                    AMap.convertFrom(([res.data.longitude, res.data.latitude]), gps_type, function (status, result) {
                        if (result.info === 'ok') {
                            var resLnglat = result.locations[0];
                            if (state.openOne) {
                                conMap.setZoomAndCenter(19, [resLnglat.lng, resLnglat.lat]); //设置地图中心点
                                state.openOne = false
                            }
                            marker.setAngle(course);
                            marker.setPosition([resLnglat.lng, resLnglat.lat]);
                        }
                    });
                } else {
                    if (state.openOne) {
                        conMap.setZoomAndCenter(19, [0, 0]); //设置地图中心点
                        state.openOne = false
                    }
                    marker.setAngle(0);
                    marker.setPosition([0, 0]);
                    // marker.setPosition([118.216513, 36.810216]);
                }
            })
        }
        // const open = () => {
        //     state.count++
        //     if (state.count % 2 !== 0) {
        //         show.value = true
        //     } else {
        //         show.value = false
        //     }
        // }
        const decimal = (data, value) => {
            if (state.carInfo.online_status !== "离线") {
                if (data) {
                    if (data !== "--") {
                        return Number(data).toFixed(value)
                    }
                }
            }
            return "--"
        }
        const car_decimal = (data) => {
            if (state.carInfo.online_status !== "离线") {
                if (data) {
                    return data
                }
            }
            return "--"
        }
        // 版本号
        const edition = (major, sub, revised, date) => {
            if (state.carInfo.online_status !== "离线") {
                if (major && sub && revised && date) {
                    if ([major, sub, revised, date].indexOf("--")) {
                        return 'V' + major + '.' + sub + '.' + revised + '.' + date
                    }
                }
            }
            return "--"
        }
        onMounted(() => {
            getMap()
            getCar()
        })

        onBeforeUnmount(() => {
            marker = null
            conMap && conMap.destroy();
            clearInterval(timer)
        })
        return {
            decimal,
            car_decimal,
            edition,
            openDialog,
            filterTableData,
            cellClick,
            // open,
            show,
            search,
            loading,
            ...toRefs(state),
        };
    },
})
</script>
<style>
#containers {
    width: 100%;
    height: 100%;
}

.common-layouts {
    width: 100%;
    height: 100%;
    display: flex;
}

.amap-logo {
    display: none !important;
    visibility: hidden !important;
}

.amap-copyright {
    display: none !important;
    visibility: hidden !important;
}
</style>
<style scoped>
.main_boxs {
    width: 96.2%;
    height: 100%;
}

.main_maps {
    width: 100%;
    height: 70%;
    display: flex;
    justify-content: center;
    align-content: center;
    position: relative;
}

.ganzhi_noxs {
    width: 100%;
    height: 29%;
}

.car_status {
    width: 200px;
    height: 100%;
    margin-left: 60px;
    line-height: 45px;
    color: #fff;
    float: left;
}

.gps_status {
    width: 200px;
    height: 100%;
    margin-left: 40px;
    line-height: 45px;
    color: #fff;
    float: left;
}
</style>
